import React from 'react';
import { Checkbox, LineOption as LineOptionComponent } from '../shape.map';
import type { LineOption, ShowLineOption } from '@/types/properties';
import styles from '../../../styles/global.module.css';
import type { DynamicComponentProps } from '@/types/commontypes';

const ShowLineOptionComponent: React.FC<DynamicComponentProps<ShowLineOption>> = ({ label, value, onChange }) => {
  // set default values if value is undefined
  const safeValue: ShowLineOption = value ?? {
    show: true,
    strokeStyle: '#787B86',
    strokeWidth: 1,
    strokeDasharray: 'Dash',
  };
  const isEnabled = safeValue.show !== false;

  const handleVisibilityChange = (checked: boolean) => {
    onChange({ ...safeValue, show: checked });
  };

  const handleLineOptionChange = (lineOption: LineOption) => {
    onChange({ ...safeValue, ...lineOption });
  };

  return (
    <div className={styles.property_row}>
      <label className={styles.property_label}>{label}</label>
      <div className={styles.property_value}>
        <Checkbox value={isEnabled} onChange={handleVisibilityChange} />
        <LineOptionComponent value={safeValue} onChange={handleLineOptionChange} disabled={!isEnabled} />
      </div>
    </div>
  );
};

export default ShowLineOptionComponent;
